import ReactDOM from 'react-dom';
import React, { ReactElement } from 'react';
import HeaderBarBannerV2 from '../BarBannerV2';

const rootEl = typeof document !== 'undefined' ? document.querySelector('#wwOneHeader__BannerBar') : false;

interface DetachableBannerBarProps {
    detachedHeaderMode: boolean;
}

const DetachableBannerBar: React.FC<DetachableBannerBarProps> = ({ detachedHeaderMode }): ReactElement | null => {
    if (detachedHeaderMode && !rootEl) {
        return null;
    }

    /* We need a div here and cannot use a fragment. 
       Ticket P100-3332 mentions that when activating the HeaderBarBanner,
        the page is displayed for some time in a broken way.
       This is the case because React assigns the dom element incorrectly after hydration. 
       This div solves the problem.
    */
    const component = (
        <div>
            <HeaderBarBannerV2 />
        </div>
    );

    if (detachedHeaderMode && rootEl) {
        return ReactDOM.createPortal(component, rootEl);
    }

    return component;
};

export default DetachableBannerBar;
